<template>
	<div>
		<fieldset class="inline">
			<legend>Coordonnées de l'établissement</legend>
			<b-form-group
				id="input-group-title"
				label="Nom commercial"
				label-for="title"
				description=""
			>
				<b-form-input
					id="title"
					type="text"
					v-model="legal.title"
					@input="$emit('update:title', $event)"
					required
					placeholder="Ex. Hôtel de la Poste"
				></b-form-input>
			</b-form-group>

			<b-form-group
				id="input-group-stars"
				label="Nombre d'étoiles"
				label-for="stars"
				description=""
			>
				<b-form-select
					id="stars"
					v-model="legal.stars"
					:options="[
						{ value: '0', text: 'Non classé' },
						{ value: '1', text: '1' },
						{ value: '2', text: '2' },
						{ value: '3', text: '3' },
						{ value: '4', text: '4' },
						{ value: '5', text: '5' }
					]"
					@input="$emit('update:stars', $event)"
					required
				></b-form-select>
			</b-form-group>

			<b-form-group
				id="input-group-address"
				label="Adresse"
				label-for="address"
				description=""
			>
				<b-form-input
					id="address"
					type="text"
					v-model="legal.address"
					@input="$emit('update:address', $event)"
					required
					placeholder="Ex. 1 Boulevarde de la Liberté"
				></b-form-input>
			</b-form-group>

			<b-form-group
				id="input-group-address2"
				label="Adresse ligne 2"
				label-for="address2"
				description=""
			>
				<b-form-input
					id="address2"
					type="text"
					v-model="legal.address2"
					@input="$emit('update:address2', $event)"
					required
					placeholder=""
				></b-form-input>
			</b-form-group>

			<b-form-group
				id="input-group-post-code"
				label="Code postal"
				label-for="post_code"
				description=""
			>
				<b-form-input
					id="post_code"
					type="text"
					v-model="legal.post_code"
					@input="$emit('update:post_code', $event)"
					required
					placeholder=""
				></b-form-input>
			</b-form-group>

			<b-form-group
				id="input-group-city"
				label="Ville"
				label-for="city"
				description=""
			>
				<b-form-input
					id="city"
					type="text"
					v-model="legal.city"
					@input="$emit('update:city', $event)"
					required
					placeholder=""
				></b-form-input>
			</b-form-group>

			<b-form-group
				id="input-group-publication_director"
				label="Nom du contact principal"
				label-for="publication_director"
				description=""
			>
				<b-form-input
					id="publication_director"
					type="text"
					v-model="legal.publication_director"
					@input="$emit('update:publication_director', $event)"
					required
					placeholder=""
				>
				</b-form-input>
			</b-form-group>

			<b-form-group
				id="input-group-telephone"
				label="Téléphone principal de l'établissement"
				label-for="telephone"
				description=""
			>
				<b-form-input
					id="telephone"
					type="text"
					v-model="legal.telephone"
					@input="$emit('update:telephone', $event)"
					required
					placeholder=""
				></b-form-input>
			</b-form-group>

			<b-form-group
				id="input-group-email"
				label="Email principal de l'établissement"
				label-for="email"
				description=""
			>
				<b-form-input
					id="email"
					type="text"
					v-model="legal.email"
					@input="$emit('update:email', $event)"
					required
					placeholder=""
				></b-form-input>
			</b-form-group>
		</fieldset>

		<fieldset class="inline">
			<legend>Mentions légales</legend>
			<b-form-group
				id="input-group-site_owner"
				label="Raison sociale"
				label-for="site_owner"
				description=""
			>
				<b-form-input
					id="site_owner"
					type="text"
					v-model="legal.site_owner"
					@input="$emit('update:site_owner', $event)"
					required
					placeholder=""
				></b-form-input>
			</b-form-group>

			<b-form-group
				id="input-group-site_url"
				label="Votre nom de domaine principal"
				label-for="site_url"
				description="L'adresse de votre site"
			>
				<b-form-input
					id="site_url"
					type="text"
					v-model="legal.site_url"
					@input="$emit('update:site_url', $event)"
					required
					placeholder=""
				></b-form-input>
			</b-form-group>

			<b-form-group
				id="input-group-legal_status"
				label="Forme juridique"
				label-for="legal_status"
				description=""
			>
				<b-form-input
					id="legal_status"
					type="text"
					v-model="legal.legal_status"
					@input="$emit('update:legal_status', $event)"
					required
					placeholder=""
				>
				</b-form-input>
			</b-form-group>

			<b-form-group
				id="input-group-business_number"
				label="Numéro d'inscription au registre de commerce et des société"
				label-for="business_number"
				description=""
			>
				<b-form-input
					id="business_number"
					type="text"
					v-model="legal.business_number"
					@input="$emit('update:business_number', $event)"
					required
					placeholder=""
				>
				</b-form-input>
			</b-form-group>

			<b-form-group
				id="input-group-business_address"
				label="Siège social"
				label-for="business_address"
				description=""
			>
				<b-form-input
					id="business_address"
					type="text"
					v-model="legal.business_address"
					@input="$emit('update:business_address', $event)"
					required
					placeholder=""
				>
				</b-form-input>
			</b-form-group>

			<b-form-group
				id="input-group-tva_number"
				label="Numéro de TVA INTRACOMMUNAUTAIRE"
				label-for="tva_number"
				description=""
			>
				<b-form-input
					id="tva_number"
					type="text"
					v-model="legal.tva_number"
					@input="$emit('update:tva_number', $event)"
					required
					placeholder=""
				>
				</b-form-input>
			</b-form-group>

			<b-form-group
				id="input-group-capital"
				label="Capital social"
				label-for="capital"
				description=""
			>
				<b-form-input
					id="capital"
					type="text"
					v-model="legal.capital"
					@input="$emit('update:capital', $event)"
					required
					placeholder=""
				>
				</b-form-input>
			</b-form-group>

			<!-- <b-form-group
			id="input-group-publication_director"
			label="Directeur de la publication"
			label-for="publication_director"
			description=""
		>
			<b-form-input
				id="publication_director"
				type="text"
				v-model="legal.publication_director"
				@input="$emit('update:publication_director', $event)"
				required
				placeholder=""
			>
			</b-form-input>
		</b-form-group>

		<b-form-group
			id="input-group-publication_director_contact"
			label="Contact du directeur de la publication (email ou téléphone)"
			label-for="publication_director_contact"
			description=""
		>
			<b-form-input
				id="publication_director_contact"
				type="text"
				v-model="legal.publication_director_contact"
				@input="$emit('update:publication_director_contact', $event)"
				required
				placeholder=""
			>
			</b-form-input>
		</b-form-group>

		<b-form-group
			id="input-group-consumer_mediator"
			label="Les coordonnées de votre médiateur à la consommation"
			label-for="consumer_mediator"
			description=""
		>
			<b-form-input
				id="consumer_mediator"
				type="text"
				v-model="legal.consumer_mediator"
				@input="$emit('update:consumer_mediator', $event)"
				required
				placeholder=""
			>
			</b-form-input>
		</b-form-group> -->
		</fieldset>
	</div>
</template>

<script>
export default {
	name: "FormLegal",
	props: ["legal"]
};
</script>